var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    class: _vm.theme.header,
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_c('v-row', {
    attrs: {
      "align-items": "center"
    }
  }, [_c('v-col', [_vm._t("title")], 2), _vm._v(" "), _c('v-col', {
    class: _vm.theme.action
  }, [_vm._t("caption"), _vm._v(" "), _c('v-icon-button', {
    class: _vm.theme.button,
    attrs: {
      "grey": ""
    }
  }, [_vm._v("\n                    expand_more\n                ")])], 2)], 1)], 1), _vm._v(" "), _c('v-animation-height', {
    attrs: {
      "height": _vm.height
    }
  }, [_vm._t("default")], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78c7023d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Expansion/Expansion.vue
// module id = 631
// module chunks = 0